//  check if pur-facet-filter is defined or not
if (!customElements.get('pur-facet-filter')) {
    // get facet filter settings which are defined in the snippets/facet-filter-config.liquid file
    const facetFilterSettings = window.FACET_FILTER.settings;
    // create a new template element
    let facetFilterTemplate = document.createElement("template");

    // set the template content
    facetFilterTemplate.innerHTML = `
        <div class="container customtabcollection advanced_search_tabs">
            <div class="filter-car-home">
                <ul class="nav nav-pills filtertabnav">
                    <li>
                        <a data-toggle="pill" href="#cartab1" class="searchtab carfiltertab active">
                        <div class="filter-car">
                            <div class="filter-car-title">
                                ${facetFilterSettings.car_filter_title ? `<h3 class="display-car-title">${facetFilterSettings.car_filter_title}</h3>` : ''}
                            </div>
                        </div>
                        </a>
                    </li>
                    <li class="home-filter-tab">
                        <a data-toggle="pill" href="#hometab2" class="searchtab homeairtab">
                        <div class="filter-home">
                            <div class="tag-coming-soon">Coming Soon</div>
                            <div class="filter-home-title">
                                ${facetFilterSettings.home_filter_title ? `<h3 class="display-car-title">${facetFilterSettings.home_filter_title}</h3>` : ''}
                            </div>
                        </div>
                        </a>
                    </li>
                </ul>
                <button
                    type="button"
                    class="facet-home-filter-clear facet-home-filter-clear--hidden"
                    data-home-filter-clear-all
                    hidden
                >
                    Clear All
                </button>
            </div>
        </div>
        <div class="container searchtabcontent">
            <div class="searchPadding_container">
                <div class="tab-content searchInnerCont">
                    <div id="cartab1" class="tab-pane filtercontent filtercarcontent active" >    
                        <div class="search-filters-page"> 
                            <div class="search-filters-page-inner">
                                <div class="search-filters-wrap">
                                    <form id="fixed-filter-form" class="fixed-filter-form advanceform" action="javascript:void(0)">
                                        <input type="hidden" name="baseVehicleId" id="baseVehicleId" value="N/A" />
                                        <div class="filter-form-inputs" data-car-filter>
                                            <label style="display: none!important">Search Year</label>
                                            <select data-facet="year" name="searchYear" id="termYear" class="facet__select facet__select_ymm area autocompInputs form-control advanceformselect" placeholder="Vehicle Year">
                                                <option class="disabled" disabled="" selected="" value="">Vehicle Year</option>
                                            </select>
                                            <label style="display: none!important">Search Make</label>
                                            <select data-facet="make" name="searchMake" id="termMake" class="facet__select facet__select_ymm area autocompInputs form-control advanceformselect" placeholder="Vehicle Make">
                                                <option class="disabled" disabled="" selected="" value="">Vehicle Make</option>
                                            </select>
                                            <label style="display: none!important">Search Model</label>
                                            <select data-facet="model" name="searchModel" id="termModel" class="facet__select facet__select_ymm area autocompInputs form-control advanceformselect" placeholder="Vehicle Model">
                                                <option class="disabled" disabled="" selected="" value="">Vehicle Model</option>
                                            </select>
                                            <div id="extra-facet-filters"></div>
                                        </div>
                                        <div class="filter-error-message" data-car-filter-error-msg></div>
                                        <input style="display:none;" type="button" class="btn btn--primary btn-filter-result" value="Search" data-car-filter-btn/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="hometab2" class="hm-filter-wrap tab-pane filtercontent homecarcontent">
                        <div class="search-filters-page"> 
                            <div class="search-filters-page-inner">
                                <div class="search-filters-wrap">
                                    <form  action="javascript:void(0)" method="get"  id="fixed-home-filter" class="fixed-home-filter fixed-filter-form advanceform">
                                        <div class="filter-form-inputs">
                                            <select data-facet="depth" name="searchDepth" id="searchDepth" class="facet__select facet__select_home area autocompInputs form-control advanceformselect" placeholder="Filter Thickness">
                                                <option value="" selected="" value="">Filter Thickness</option>
                                            </select>
                                            <select data-facet="width" name="searchWidth" id="searchWidth" class="facet__select facet__select_home area autocompInputs form-control advanceformselect" placeholder="Filter Width">
                                                <option value="" selected="" value="">Filter Width</option>
                                            </select>
                                            <select data-facet="height" name="searchHeight" id="searchHeight" class="facet__select facet__select_home area autocompInputs form-control advanceformselect" placeholder="Filter Length">
                                                <option value="" selected="" value="">Filter Length</option>
                                            </select>
                                        </div>
                                        <div class="filter-error-message" data-home-filter-error-msg></div>
                                        <input style="display:none;" type="button" class="btn btn--primary btn-hm-filter-result" value="Search" data-home-filter-btn/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>    
                    <div class="vinSearchField_inner">
                        <div class="vinSearch_blocks vinLeftBlock">
                            <h2 class="section_title">VIN Number Search</h2>
                        </div>
                        <div class="vinSearch_blocks vinRighBlock">
                            <input placeholder="VIN Number Search" type="text" class="search-field" id="mbk_vinSearchField" name="[vin-search]" />
                            <input type="submit" value="Search" id="mbk_vinSearchButton" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    // define API URLs
    const autoCompleteAPI = window?.FACET_FILTER?.settings?.autoCompleteAPIURL || 'https://api.pureflowair.com/api/v5/common/autocompleteData';
    const API_FACET_BASE_URL = autoCompleteAPI;//"https://api.pureflowair.com/api/v3/common/autocompleteData";
    const API_PRODUCT_BASE_URL = "https://pureflow.pgiproduct.com/api/v1/getProducts";
    const API_BASE_URL = "https://pgfilters.pgiproduct.com";
    const API_BASE_URL_NEW = "https://pureflow.pgiproduct.com";
    const FACETS_ATTRIBUTES = {
        "engineBaseId": "engine",
        "engine":"engineBaseId",
        "AspirationID":"Aspiration" ,
        "BedLengthID":"Bed Length" ,
        "BedTypeID":"Bed Type" ,
        "BodyNumDoorsID":"Body Num Doors" ,
        "BodyTypeID":"Body Type" ,
        "BrakeABSID":"Brake ABS" ,
        "BrakeSystemID":"Brake System" ,
        "CylinderHeadTypeID":"Cylinder Head Type" ,
        "DriveTypeID":"Drive Type" ,
        "EngineDesignationID":"Engine Designation" ,
        "EngineMfrID":"Engine Mfr" ,
        "EngineVersionID":"Engine Version" ,
        "EngineVINID":"Engine VIN" ,
        "FrontBrakeTypeID":"Front Brake Type" ,
        "FrontSpringTypeID":"Front Spring Type" ,
        "FuelDeliverySubTypeID":"Fuel Delivery SubType" ,
        "FuelDeliveryTypeID":"Fuel Delivery Type" ,
        "FuelSystemControlTypeID":"Fuel System Control Type" ,
        "FuelSystemDesignID":"Fuel System Design" ,
        "FuelTypeID":"Fuel Type" ,
        "IgnitionSystemTypeID":"Ignition System Type" ,
        "MfrBodyCodeID":"Mfr Body Code" ,
        "PowerOutputID":"Power Output" ,
        "RearBrakeTypeID":"Rear Brake Type" ,
        "RearSpringTypeID":"Rear Spring Type" ,
        "RegionID":"Region" ,
        "SteeringTypeID":"Steering Type" ,
        "SteeringSystemID":"Steering System" ,
        "SubModelID":"Sub Model" ,
        "TransElecControlledID":"Trans Elec Controlled" ,
        "TransmissionControlTypeID":"Transmission Control Type" ,
        "TransmissionMfrID":"Transmission Mfr" ,
        "TransmissionMfrCodeID":"Transmission Mfr Code" ,
        "TransmissionNumSpeedsID":"Transmission Num Speeds" ,
        "TransmissionTypeID":"Transmission Type" ,
        "ValvesPerEngineID":"Valves Per Engine" ,
        "WheelBaseID":"Wheel Base" 
    };

    const YMM_ATTRIBUTES = {
        "year":"termYear",
        "make":"termMake",
        "model":"termModel"
    }

    // define facet filter class which extends the HTMLElement class
    class PurFacetFilter extends HTMLElement {

        // define the constructor for the class
        constructor() {
            super();
            this.settings = window.FACET_FILTER.settings; // get the settings from the global variable
            this.appendChild(facetFilterTemplate.content.cloneNode(true)); // append the template to the element
            this.searchQuery = ""; // define the search query
            this.homeSearchQuery = ""; // define the home search query
            this.isHomeFilterApply = false; // define the home filter apply flag
            this.isFilterApply = false; // define the filter apply flag
            this.qualifierName;
            this.singleEngine;
            this.skipEngine;
            this._homeFilterCache = null;
            this.hasForceReload = (new URLSearchParams(location.search)).get('force_reload') === 'yes';
            this.selectedFilter = {}; // define the selected filter
            this.selectedHomeFilter = {}; // define the selected home filter
            this.staticDropdown = ["year", "make", "model", "engine", "region"]; // define the static dropdown with default values
        }

        /** When URL includes homepageSearch, keep legacy YMM/home Select2 behavior; otherwise use improved placeholders + optional auto-open. */
        isHomepageSearchURL() {
            return typeof window !== 'undefined' && window.location.search.includes('homepageSearch');
        }

        isHomeFiltersSearchURL() {
            const params = new URLSearchParams(window.location.search);
            return params.get('type') === 'product' && params.get('q') === 'home-filters';
        }

        isHvacHomeSearchURL() {
            const params = new URLSearchParams(window.location.search);
            const searchQ = (params.get('q') || '').trim();
            const parts = searchQ.split(',');
            return parts[0].trim().toLowerCase() === 'hvac' && parts.length >= 4;
        }

        isOnHvacSearchResultsPage() {
            return window.location.pathname === '/search' && this.isHvacHomeSearchURL();
        }

        _getActiveSearchTabFromDom() {
            if (document.querySelector('.homeairtab.active')) {
                return '#hometab2';
            }
            if (document.querySelector('.carfiltertab.active')) {
                return '#cartab1';
            }
            return null;
        }

        _getSearchResultsTabHash() {
            const fromDom = this._getActiveSearchTabFromDom();
            if (fromDom) {
                return fromDom;
            }

            const hash = window.location.hash;
            if (hash === '#cartab1' || hash === '#hometab2') {
                return hash;
            }
            if (this.isHomeFiltersSearchURL() || this.isHvacHomeSearchURL()) {
                return '#hometab2';
            }
            return '#cartab1';
        }

        _shouldShowHomeSearchResultsPanel() {
            return this._getSearchResultsTabHash() === '#hometab2';
        }

        _syncCabinEmptySpacing(showHome) {
            const carPanel = document.querySelector('[data-search-filter-panel="car"]');
            const hasCarProducts = Boolean(
                carPanel && !carPanel.hidden && carPanel.querySelector('.halo-item .product-card')
            );
            document.documentElement.classList.toggle(
                'search-cabin-results-empty',
                !showHome && !hasCarProducts
            );
        }

        _syncHomeEmptySpacing(showHome) {
            const homePanel = document.querySelector('[data-search-filter-panel="home"]');
            const hasHomeProducts = Boolean(
                homePanel && !homePanel.hidden && homePanel.querySelector('.halo-item .product-card')
            );
            document.documentElement.classList.toggle(
                'search-home-results-empty',
                showHome && !hasHomeProducts
            );
        }

        _applySearchResultsPanelVisibility(showHome) {
            const carPanel = document.querySelector('[data-search-filter-panel="car"]');
            const homePanel = document.querySelector('[data-search-filter-panel="home"]');
            const isHvacResults = this.isHomeFiltersSearchURL() || this.isHvacHomeSearchURL();
            const root = document.documentElement;

            root.classList.toggle('search-results-home-tab', showHome);
            root.classList.toggle('search-results-car-tab', !showHome);
            this._syncCabinEmptySpacing(showHome);

            if (!carPanel || !homePanel) {
                this._syncHomeEmptySpacing(showHome);
                return false;
            }

            if (showHome) {
                if (isHvacResults) {
                    root.classList.add('hvac-home-search-results');
                    carPanel.setAttribute('data-hvac-hidden', '');
                    homePanel.setAttribute('data-hvac-visible', '');
                } else {
                    root.classList.remove('hvac-home-search-results');
                    carPanel.removeAttribute('data-hvac-hidden');
                    homePanel.removeAttribute('data-hvac-visible');
                }
                carPanel.hidden = true;
                homePanel.hidden = false;
            } else {
                root.classList.remove('hvac-home-search-results');
                carPanel.removeAttribute('data-hvac-hidden');
                homePanel.removeAttribute('data-hvac-visible');
                carPanel.hidden = false;
                homePanel.hidden = true;
            }

            document.querySelectorAll('[data-search-pagination="car"]').forEach((el) => {
                el.hidden = showHome;
            });
            document.querySelectorAll('[data-search-pagination="home"]').forEach((el) => {
                el.hidden = !showHome;
            });

            this._syncHomeEmptySpacing(showHome);
            return true;
        }

        _syncSearchResultsPanels() {
            if (window.location.pathname !== '/search') return;

            const apply = () => {
                return this._applySearchResultsPanelVisibility(this._shouldShowHomeSearchResultsPanel());
            };

            if (apply()) return;

            const observer = new MutationObserver(() => {
                if (apply()) observer.disconnect();
            });
            observer.observe(document.documentElement, { childList: true, subtree: true });
            window.setTimeout(() => observer.disconnect(), 10000);
        }

        /** Non-homepageSearch: first YMM option must be selectable (value "") so the browser does not jump to the first real option. */
        applyImprovedSearchPlaceholders() {
            ['termYear', 'termMake', 'termModel'].forEach((id) => {
                const el = this.querySelector('#' + id);
                if (!el || !el.options.length) return;
                const o = el.options[0];
                o.disabled = false;
                o.removeAttribute('disabled');
                o.value = '';
                o.classList.remove('disabled');
            });
        }

        // define the connectedCallback function this will trigger when the element is attached to the DOM
        connectedCallback() {
            if (!this.isHomepageSearchURL()) {
                this.applyImprovedSearchPlaceholders();
            }
            // Additive keyboard UX: allow Tab-to-select when Select2 is open.
            // Safe for both homepageSearch and non-homepageSearch flows.
            this.bindSelect2TabKeyBehavior();
            this.preSelectedTab(); // preselect the tab
            this._syncSearchResultsPanels();
            if (!this._searchResultsPanelHashListener) {
                this._searchResultsPanelHashListener = () => this._syncSearchResultsPanels();
                window.addEventListener('hashchange', this._searchResultsPanelHashListener);
            }
            this.getSelectedFilterFromURL(); // get the selected filter from the URL before populating dropdowns
            this.fetchFacetData({},false); // fetch the facet data
            this.setupEventListeners(); // setup the event listeners for YMM filter
            this.preFillFacetDropdown(); // prefill the facet filter dropdown
            if (document.body.classList.contains('template-index')) {
                this._prepareIndexHomeFilters();
            } else {
                if (Object.keys(this.selectedHomeFilter).length === 0) {
                    this.fetchHomeData("","","",false); // fetch the home data
                }
                this.preFillHomeDropdown(); // prefill the home filter dropdown
            }
            this._clearHomeFilterErrorOnResultsPage();
            this._updateHomeFilterClearAllVisibility();
        }

        _isIndexHomepageFacetFilter() {
            return document.body.classList.contains('template-index')
                && this.classList.contains('homepage-filter-main');
        }

        _shouldUseSelect2ForHomeDropdown(isExternalRoot = false) {
            if ($(window).width() <= 767) return false;
            if (typeof $.fn.select2 !== 'function') return false;
            if (!isExternalRoot && this._isIndexHomepageFacetFilter()) return false;
            return true;
        }

        _handleHomeFilterSelectChange(facetHomeFilter) {
            const _facet = facetHomeFilter.getAttribute('data-facet') || 'depth';
            let searchDepth = this.querySelector('#searchDepth')?.value || '';
            let searchWidth = this.querySelector('#searchWidth')?.value || '';
            let searchHeight = this.querySelector('#searchHeight')?.value || '';

            if (_facet === 'depth') {
                searchWidth = '';
                searchHeight = '';
                this.fillHomeDropdown('searchWidth', [], 'Filter Width', false);
                this.fillHomeDropdown('searchHeight', [], 'Filter Length', false);
            } else if (_facet === 'width') {
                searchHeight = '';
                this.fillHomeDropdown('searchHeight', [], 'Filter Length', false);
            }

            return Promise.resolve(this.fetchHomeData(searchDepth, searchWidth, searchHeight))
                .finally(() => this._updateHomeFilterClearAllVisibility());
        }

        _homeFilterHasAnySelection() {
            return ['searchDepth', 'searchWidth', 'searchHeight'].some((id) => {
                const el = this.querySelector(`#${id}`);
                return Boolean(el?.value);
            });
        }

        _updateHomeFilterClearAllVisibility() {
            const clearBtn = this.querySelector('[data-home-filter-clear-all]');
            if (!clearBtn) return;

            const homeTabActive = Boolean(this.querySelector('.homeairtab.active'));
            const showClear = homeTabActive && this._homeFilterHasAnySelection();

            clearBtn.classList.toggle('facet-home-filter-clear--hidden', !showClear);
            clearBtn.hidden = !showClear;
            clearBtn.disabled = !showClear;
        }

        _clearAllHomeFilters() {
            const redirectAfterClear = this.isOnHvacSearchResultsPage()
                || (window.location.pathname === '/search' && this.isHvacHomeSearchURL());

            this.selectedHomeFilter = {};
            this._homeFilterCache = null;
            this._clearHomeFilterErrorOnResultsPage();

            ['searchDepth', 'searchWidth', 'searchHeight'].forEach((id) => {
                const el = this.querySelector(`#${id}`);
                if (!el) return;
                el.value = '';
                const $el = $(el);
                if ($el.data('select2')) {
                    $el.val('').trigger('change.select2');
                }
            });

            if (redirectAfterClear) {
                window.location.href = '/search#hometab2';
                return;
            }

            this.fillHomeDropdown('searchWidth', [], 'Filter Width', false);
            this.fillHomeDropdown('searchHeight', [], 'Filter Length', false);
            Promise.resolve(this.fetchHomeData('', '', '', false))
                .finally(() => {
                    this._updateHomeFilterClearAllVisibility();
                    if (window.location.pathname === '/search') {
                        this._syncHomeEmptySpacing(true);
                    }
                });
        }

        _bindHomeFilterSelectListeners() {
            const __this = this;
            const facetHomeFilters = this.querySelectorAll('.facet__select_home');
            const useNativeChange = this._isIndexHomepageFacetFilter() || $(window).width() < 767;

            facetHomeFilters.forEach((facetHomeFilter) => {
                if (facetHomeFilter.dataset.homeFilterBound === 'true') {
                    return;
                }
                facetHomeFilter.dataset.homeFilterBound = 'true';

                if (useNativeChange) {
                    facetHomeFilter.addEventListener('change', () => {
                        __this._handleHomeFilterSelectChange(facetHomeFilter);
                    });
                } else {
                    $(facetHomeFilter).on('select2:select', () => {
                        __this._handleHomeFilterSelectChange(facetHomeFilter);
                    });
                }
            });
        }

        _prepareIndexHomeFilters() {
            if (!this._isIndexHomepageFacetFilter()) {
                return Promise.resolve();
            }

            this.querySelectorAll('.facet__select_home').forEach((select) => {
                const $select = $(select);
                if ($select.data('select2')) {
                    $select.select2('destroy');
                }
            });

            this._homeFilterCache = null;

            if (Object.keys(this.selectedHomeFilter).length > 0) {
                return Promise.resolve(this.preFillHomeDropdown());
            }

            return Promise.resolve(this.fetchHomeData('', '', '', false, true));
        }

        _clearHomeFilterErrorOnResultsPage() {
            if (!this.isOnHvacSearchResultsPage()) return;
            const errorEl = this.querySelector('[data-home-filter-error-msg]');
            if (errorEl) {
                errorEl.innerText = '';
                errorEl.hidden = true;
            }
        }

        _homeFilterFieldsHaveValues() {
            const searchHeight = this.querySelector('#searchHeight');
            const searchWidth = this.querySelector('#searchWidth');
            const searchDepth = this.querySelector('#searchDepth');
            return Boolean(
                searchDepth?.value
                && searchWidth?.value
                && searchHeight?.value
            );
        }

        /**
         * If Select2 dropdown is open and user presses Tab (desktop):
         * - select the currently highlighted option
         * - open the next dropdown (when available)
         */
        bindSelect2TabKeyBehavior() {
            // Bind once per page (multiple instances shouldn't double-bind).
            if (window.__purFacet_select2TabBound) return;
            window.__purFacet_select2TabBound = true;

            const getOpenSelectEl = function () {
                // Best: ask the selects which one is open.
                const $sels = $('select.select2-hidden-accessible');
                for (let i = 0; i < $sels.length; i++) {
                    const s = $sels[i];
                    try {
                        const $s = $(s);
                        if ($s.data('select2') && $s.select2('isOpen')) {
                            return s;
                        }
                    } catch (_) {
                        // ignore
                    }
                }

                // Fallback: Select2 container is inserted right after the <select>
                const $openContainer = $('.select2-container--open').last();
                if (!$openContainer.length) return null;
                const $selectPrev = $openContainer.prev('select');
                if ($selectPrev && $selectPrev.length) return $selectPrev[0];

                // Fallback: parse select id from select2 generated container id: select2-<id>-container
                const renderedId = $openContainer.find('.select2-selection__rendered').attr('id') || '';
                const m = renderedId.match(/^select2-(.+)-container$/);
                if (m && m[1]) {
                    const byId = document.getElementById(m[1]);
                    if (byId) return byId;
                }

                return null;
            };

            const handleTab = function (e) {
                const isTab =
                    (typeof e.key === 'string' && e.key.toLowerCase() === 'tab') ||
                    e.keyCode === 9 ||
                    e.which === 9;
                if (!isTab || e.shiftKey) return;

                const activeSelect = getOpenSelectEl();
                if (!activeSelect) return;

                const $active = $(activeSelect);
                if (!$active.data('select2')) return;

                let $toSelect = $('.select2-results__option--highlighted').first();
                if (!$toSelect.length) {
                    $toSelect = $('.select2-results__option[aria-selected="false"]').first();
                }
                if (!$toSelect.length) return;

                e.preventDefault();
                e.stopPropagation();

                // Prefer selecting via Select2 data instead of relying on DOM click simulation.
                const liData = $toSelect.data('data') || null;
                const nextValue = liData && (liData.id ?? liData.value);
                if (nextValue !== undefined && nextValue !== null && String(nextValue) !== '') {
                    $active.val(String(nextValue)).trigger('change');
                } else {
                    // fallback click
                    $toSelect.trigger('mouseenter');
                    $toSelect.trigger('mouseup');
                    $toSelect.trigger('click');
                }

                setTimeout(function () {
                    try {
                        // close current
                        if ($active.data('select2')) {
                            $active.select2('close');
                        }
                        const root =
                            activeSelect.closest('.filter-form-inputs') ||
                            activeSelect.closest('form') ||
                            document;

                        const selects = Array.prototype.slice
                            .call(root.querySelectorAll('select'))
                            .filter((s) => $(s).data('select2') && !s.classList.contains('hide'));

                        const idx = selects.indexOf(activeSelect);
                        const next = idx >= 0 ? selects[idx + 1] : null;
                        if (!next) return;

                        const $next = $(next);
                        if ($next.data('select2') && $next.find('option').length > 1) {
                            $next.select2('open');
                        }
                    } catch (_) {
                        // no-op
                    }
                }, 100);
            };

            // Use native capture listener so Tab works inside Select2's search field too.
            window.addEventListener('keydown', handleTab, true);
            document.addEventListener('keydown', handleTab, true);
        }

        // define then disconnectCallback function this will trigger when the element is detached from the DOM
        disconnectedCallback() {
            if (this._searchResultsPanelHashListener) {
                window.removeEventListener('hashchange', this._searchResultsPanelHashListener);
                this._searchResultsPanelHashListener = null;
            }
        }

        // this will use to prepare select2 data for the facet filter dropdown
        _matcher(params, data){
            
                // If there are no search terms, return all of the data
            if ($.trim(params.term) === '') {
                return data;
            }

            // Do not display the item if there is no 'text' property
            if (typeof data.text === 'undefined') {
                return null;
            }

            // `params.term` should be the term that is used for searching
            // `data.text` is the text that is displayed for the data object
            if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
                let modifiedData = $.extend({}, data, true);
                
                // You can return modified objects from here
                // This includes matching the `children` how you want in nested data sets
                return modifiedData;
            }

            // Return `null` if the term should not be displayed
            return null;
        }

        // pre-selected value for the facet dropdown if the URL has a filter
        async preFillFacetDropdown() {
            let _selectedFilter = this.selectedFilter;

            if(Object.keys(_selectedFilter).length === 0) return;

            let _dropDownFillCall = [];
            let __this = this;
            Object.keys(_selectedFilter).forEach(function(key){
                switch (key) {
                    case "baseVehicleId":
                        let baseVehicleIdSelector = __this.querySelector("#baseVehicleId");
                        baseVehicleIdSelector.value = _selectedFilter[key];    
                        break;
                    case "termYear":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear
                        },false, true));
                        break;
                    case "termMake":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake
                        },false, true));
                        break;
                    case "termModel":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake,
                            termModel: _selectedFilter?.termModel
                        },false, true));
                        break;
                    case "engineBaseId":
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake,
                            termModel: _selectedFilter?.termModel,
                            engineBaseId: _selectedFilter?.engineBaseId,
                            baseVehicleId: _selectedFilter?.baseVehicleId
                        },false, true));
                        break;
                    default: 
                        let _tmpObj = {};
                        _tmpObj[key] = _selectedFilter[key];
                        _dropDownFillCall.push(__this.fetchFacetData({
                            termYear: _selectedFilter?.termYear,
                            termMake: _selectedFilter?.termMake,
                            termModel: _selectedFilter?.termModel,
                            engineBaseId: _selectedFilter?.engineBaseId,
                            baseVehicleId: _selectedFilter?.baseVehicleId,
                            ..._tmpObj
                        },false, true));
                        break;
                }
            });
            
            let _fillAllDropdownRes = await Promise.all(_dropDownFillCall).then(response => {
                return response;
            });
            
            if(_fillAllDropdownRes.length > 0){
                Object.keys(_selectedFilter).forEach(function(key){
                    if(key === "baseVehicleId"){
                        let baseVehicleIdSelector = __this.querySelector("#baseVehicleId");
                        baseVehicleIdSelector.value = _selectedFilter[key];
                    }else{
                        __this.querySelector(`#${key}`).value = _selectedFilter[key],
                        setTimeout(() => {
                            $(`#${key}`).attr("data-select2-id") && $(`#${key}`).val(_selectedFilter[key]).trigger("change")
                        }, 500);
                    }
                });
            }
        }

        // pre-selected tab for the tab if the URL has a tab type defined as hash value
        preSelectedTab() {
            let __this = this;
            let _tab = window.location.hash;
            if (!_tab) {
                _tab = (this.isHomeFiltersSearchURL() || this.isHvacHomeSearchURL()) ? "#hometab2" : "#cartab1";
            }
            if(_tab === "#cartab1"){
                this.querySelector('[href="#cartab1"]') ? (
                    this.querySelector('[href="#cartab1"]').classList.add("active"),
                    this.querySelector('#cartab1') ? (__this.querySelector('#cartab1').classList.add("active", "show") ) : ""
                ) : undefined;
                this.querySelector('[href="#hometab2"]') ? (
                    this.querySelector('[href="#hometab2"]').classList.remove("active"),
                    this.querySelector('#hometab2') ? (
                        this.querySelector('#hometab2').classList.remove("active", "show") ) : ""
                ) : undefined;
            }else if(_tab === "#hometab2"){
                this.querySelector('[href="#cartab1"]') ? (
                    this.querySelector('[href="#cartab1"]').classList.remove("active"),
                    this.querySelector('#cartab1') ? (__this.querySelector('#cartab1').classList.remove("active", "show") ) : ""
                ) : undefined;
                this.querySelector('[href="#hometab2"]') ? (
                    this.querySelector('[href="#hometab2"]').classList.add("active"),
                    this.querySelector('#hometab2') ? (
                        this.querySelector('#hometab2').classList.add("active", "show") ) : ""
                ) : undefined;
            }
            this._updateHomeFilterClearAllVisibility();
        }

        // get the selected tab from the URL
        getCurrentActiveTab(){
            return this._getSearchResultsTabHash();
        }

        _setHomeSelectValue(dropdownId, value) {
            const selectEl = this.querySelector(`#${dropdownId}`);
            if (!selectEl || value == null || value === '') return;

            const normalized = String(value);
            selectEl.value = normalized;

            const $selectEl = $(selectEl);
            if ($selectEl.attr('data-select2-id') && $selectEl.data('select2')) {
                $selectEl.val(normalized).trigger('change.select2');
            }
        }

        // prefill the home dropdown with the selected filter values
        async preFillHomeDropdown() {
            let _selectedHomeFilter = this.selectedHomeFilter;
            if (Object.keys(_selectedHomeFilter).length === 0) return;

            const thickness = _selectedHomeFilter.termDepth != null ? String(_selectedHomeFilter.termDepth) : '';
            const width = _selectedHomeFilter.termWidth != null ? String(_selectedHomeFilter.termWidth) : '';
            const length = _selectedHomeFilter.termHeight != null ? String(_selectedHomeFilter.termHeight) : '';

            this._homeFilterCache = null;
            await this.fetchHomeData('', '', '', false, true);
            if (thickness) {
                await this.fetchHomeData(thickness, '', '', false, true);
            }
            if (thickness && width) {
                await this.fetchHomeData(thickness, width, '', false, true);
            }

            const applySelectedValues = () => {
                if (thickness) this._setHomeSelectValue('searchDepth', thickness);
                if (width) this._setHomeSelectValue('searchWidth', width);
                if (length) this._setHomeSelectValue('searchHeight', length);

                if (thickness && width && length) {
                    this.isHomeFilterApply = true;
                    this.homeSearchQuery = `/search?q=hvac,Width_${width},Height_${length},Depth_${thickness}`;
                }
                this._clearHomeFilterErrorOnResultsPage();
                this._updateHomeFilterClearAllVisibility();
            };

            if (this._isMobileFilterView()) {
                requestAnimationFrame(applySelectedValues);
            } else {
                applySelectedValues();
            }
        }

        _isMobileFilterView() {
            return window.matchMedia('(max-width: 767px)').matches;
        }

        // get selected filter values from the URL
        getSelectedFilterFromURL() {
            let urlParams = new URLSearchParams(decodeURIComponent(window.location.href));
            let advanceFilter = urlParams.get("filter") || "";
            let _filterData = (advanceFilter !== "" && advanceFilter.split("=")) || [];
            let _selectedFilter = {};
            if (_filterData.length > 0){
                let _filterValues = _filterData[1].split("|");
                if(_filterValues.length > 0){
                    for (let index = 0; index < _filterValues.length; index++) {
                        let _filterValue = _filterValues[index];
                        let _filterKeyValue = _filterValue.split(":");
                        _selectedFilter[_filterKeyValue[0]] = _filterKeyValue[1];        
                    }
                }
            }
            let _selectedHomeFilter = {};
            if (window.location.pathname === '/search') {
                const params = new URLSearchParams(window.location.search);
                const homeQuery = params.get('q') || '';
                const _homeSearch = homeQuery.split(',');
                if (_homeSearch[0] === 'hvac' && _homeSearch.length >= 4) {
                    const parseHvacDimension = (part) => {
                        const match = part && String(part).match(/\d+/g);
                        return match ? match.join('') : '';
                    };
                    _selectedHomeFilter = {
                        termWidth: parseHvacDimension(_homeSearch[1]),
                        termHeight: parseHvacDimension(_homeSearch[2]),
                        termDepth: parseHvacDimension(_homeSearch[3])
                    };
                }
            }
            this.selectedFilter = _selectedFilter;
            this.selectedHomeFilter = _selectedHomeFilter;

            let vinFilter = urlParams.get("vin") || "";
            const vinField = document.querySelector('#mbk_vinSearchField');
            if (vinField) {
                vinField.value = vinFilter;
            }
        }

        // spinner for the search results
        facetWaitSpinner(isLoading = false){
            let _facetFormContainer = this.querySelector('#fixed-filter-form');
            if(_facetFormContainer){
                isLoading === true ? (
                    _facetFormContainer.classList.add("disabled-field")
                ) : (
                    _facetFormContainer.classList.remove("disabled-field")
                )
                
            }
        }
 
        clearAllFilters(clearFields) {
            let _filterQuery = {};
            let facetYmmFilters = document.querySelectorAll(".facet__select_ymm") && Array.prototype.slice.call(document.querySelectorAll(".facet__select_ymm")) || [];
            let baseVehicleIdSelector = this.querySelector("#baseVehicleId");
            clearFields = clearFields || ["termMake", "termModel", "engineBaseId"];
            if(facetYmmFilters.length > 0){
                for (let index = 0; index < facetYmmFilters.length; index++) {
                    let facetYmmFilter = facetYmmFilters[index];
                    let _facetFilterId = facetYmmFilter.getAttribute("id");
                    if(facetYmmFilter.value !== "" && clearFields.includes(_facetFilterId)){
                        facetYmmFilter.value = "";
                        if(_facetFilterId === "engineBaseId" && baseVehicleIdSelector){
                            baseVehicleIdSelector.value = "";
                        }
                    }
                }
            }
            return _filterQuery;
        }

        buildFilterQuery(){
            let _filterQuery = {};
            let facetYmmFilters = document.querySelectorAll(".facet__select_ymm") && Array.prototype.slice.call(document.querySelectorAll(".facet__select_ymm")) || [];
            let baseVehicleIdSelector = this.querySelector("#baseVehicleId");
            if(facetYmmFilters.length > 0){
                for (let index = 0; index < facetYmmFilters.length; index++) {
                    let facetYmmFilter = facetYmmFilters[index];
                    if(facetYmmFilter.value !== ""){
                        _filterQuery[facetYmmFilter.getAttribute("id")] = facetYmmFilter.value;
                        if(facetYmmFilter.getAttribute("id") === "engineBaseId" && baseVehicleIdSelector){
                            _filterQuery["baseVehicleId"] = baseVehicleIdSelector.value;
                        }
                    }
                }
            }
            return _filterQuery;
        }

        // YMM facets dropdown change events
        setupEventListeners() {
            let __this = this;
            let facetYmmFilters = document.getElementsByClassName("facet__select_ymm");
            let extraFacetFilterTemplate = this.querySelector("#extra-facet-filters");
            if(facetYmmFilters.length > 0){
                facetYmmFilters = Array.prototype.slice.call(facetYmmFilters);
                for (let index = 0; index < facetYmmFilters.length; index++) {
                    let facetYmmFilter = facetYmmFilters[index];
                    if($(window).width()<767){
                        facetYmmFilter.addEventListener("change", (e) => {
                            let _facetFilter = e.target;
                            let _facet = _facetFilter.getAttribute("data-facet") || "year";
                            if(_facet === "year"){
                                this.clearAllFilters(["termMake", "termModel"]);
                                extraFacetFilterTemplate.innerHTML = "";
                                this.fillDropdown('termMake',[],"Vehicle Make");
                                this.fillDropdown('termModel',[],"Vehicle Model");
                            }else if(_facet === "make"){
                                //this.clearAllFilters(["termModel", "engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                                this.fillDropdown('termModel',[],"Vehicle Model");
                            }else if(_facet === "model"){
                                //this.clearAllFilters(["engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                            }
                            let _filterQuery = __this.buildFilterQuery();
                            __this.fetchFacetData(_filterQuery);
                        });
                    }else if($(window).width()>767){
                        
                        $(facetYmmFilter).on("select2:select", (e) => {
                            let _facetFilter = e.target;
                            let _facet = _facetFilter.getAttribute("data-facet") || "year";
                            
                            if(_facet === "year"){
                                extraFacetFilterTemplate.innerHTML = "";
                                this.selectedFilter = {};
                                this.clearAllFilters(["termMake", "termModel"]);
                                this.fillDropdown('termMake',[],"Vehicle Make");
                                this.fillDropdown('termModel',[],"Vehicle Model");
                            }else if(_facet === "make"){
                                //this.clearAllFilters(["termModel", "engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                                this.clearAllFilters(["termModel"]);
                                this.fillDropdown('termModel',[],"Vehicle Model");
                            }else if(_facet === "model"){
                                //this.clearAllFilters(["engineBaseId"]);
                                extraFacetFilterTemplate.innerHTML = "";
                            }
                            let _filterQuery = __this.buildFilterQuery();
                            __this.fetchFacetData(_filterQuery); 
                            
                        });
                    }
                }
            }

            // car filter button 
            let carFilterButton = this.querySelector('[data-car-filter-btn]');
            if(carFilterButton){
                carFilterButton.addEventListener("click", () => {
                    let searchYear = __this.querySelector("#termYear");
                    let searchMake = __this.querySelector("#termMake");
                    let searchModel = __this.querySelector("#termModel");
                    if(!searchYear || !searchMake || !searchModel || searchYear.selectedIndex <=0 || searchMake.selectedIndex <=0 || searchModel.selectedIndex <=0){
                        __this.querySelector('[data-car-filter-error-msg]') ? (
                            __this.querySelector('[data-car-filter-error-msg]').innerText = "Please select all the above fields"
                        ) : undefined;
                        setTimeout(function(){
                            __this.querySelector('[data-car-filter-error-msg]') ? (
                                __this.querySelector('[data-car-filter-error-msg]').innerText = ""
                            ) : undefined;
                        },2000)
                    }
                    this.searchQuery !== "" ? (
                        window.location.href = this.searchQuery
                    ) : undefined;
                    this.isFilterApply = true;
                });
            }

            this.querySelectorAll('.carfiltertab, .homeairtab').forEach((tab) => {
                tab.addEventListener('click', () => {
                    window.setTimeout(() => {
                        if (window.location.pathname === '/search') {
                            this._syncSearchResultsPanels();
                        }
                        this._updateHomeFilterClearAllVisibility();
                    }, 0);
                });
            });

            const homeFilterClearAll = this.querySelector('[data-home-filter-clear-all]');
            if (homeFilterClearAll) {
                homeFilterClearAll.addEventListener('click', (event) => {
                    event.preventDefault();
                    this._clearAllHomeFilters();
                });
            }

            // home filters
            this._bindHomeFilterSelectListeners();

             // home filter button 
            let homeFilterButton = this.querySelector('[data-home-filter-btn]');
            if(homeFilterButton){
                homeFilterButton.addEventListener("click", () => {
                    if (__this.isOnHvacSearchResultsPage()) {
                        __this._clearHomeFilterErrorOnResultsPage();
                        return;
                    }

                    if (!__this._homeFilterFieldsHaveValues()) {
                        const errorEl = __this.querySelector('[data-home-filter-error-msg]');
                        if (errorEl) {
                            errorEl.hidden = false;
                            errorEl.innerText = "Please select all the above fields";
                            setTimeout(() => {
                                errorEl.innerText = "";
                            }, 2000);
                        }
                        return;
                    }

                    if (this.homeSearchQuery !== "") {
                        window.location.href = `${this.homeSearchQuery}#hometab2`;
                    }
                    this.isHomeFilterApply = true;
                });
            }

        } 

        // use to capitalize the word
        _capitalize(word) {
            return word
            .toLowerCase()
            .replace(/\w/, firstLetter => firstLetter.toUpperCase());
        }

        createDropdown(id, dropdownVal){
            let __this = this;
            let _select = document.createElement('select');
            let extraFacetFilterTemplate = this.querySelector("#extra-facet-filters");
            _select.setAttribute('id', id === 'engine' ? FACETS_ATTRIBUTES[id] : id);
            _select.setAttribute('data-facet',id);
            _select.setAttribute('name', `search${id === 'engine' ? this._capitalize(id) : FACETS_ATTRIBUTES[id]}`);
            _select.setAttribute('placeholder', id === 'engine' ? this._capitalize(id) : FACETS_ATTRIBUTES[id]);
            _select.setAttribute('class', "facet__select facet__select_ymm area autocompInputs form-control advanceformselect hide");
            extraFacetFilterTemplate && extraFacetFilterTemplate.append(_select);
            if(dropdownVal) return;
            
            let excludeFacet = ["engineBaseId","AspirationID","RegionID"];
            if($(window).width()>767 && !excludeFacet.includes(FACETS_ATTRIBUTES[id])){
                const s2optsDyn = {
                    matcher:(params, data) => {
                        return __this._matcher(params, data);
                    },
                    dropdownPosition: 'below'
                };
                if (__this.isHomepageSearchURL()) {
                    s2optsDyn.selectOnClose = true;
                }
                if ($(_select).data('select2')) {
                    $(_select).select2('destroy');
                }
                $(_select).select2(s2optsDyn);
            } 
            if($(window).width()<767){
                _select.addEventListener("change", (e) => {
                    let _filterQuery = __this.buildFilterQuery();
                    __this.fetchFacetData(_filterQuery);
                });
            }else if($(window).width()>767){
                $(_select).on("select2:select", (e) => {
                    let _filterQuery = __this.buildFilterQuery();
                    __this.fetchFacetData(_filterQuery); 
                    
                });
            } 
        }


        // fill dropdown for the given dropdown id
        fillDropdown(dropdownId, options, placeholder, isResponseHasPartNumber = false, isNextDropdownOpen = true, dropdownVal) {
            let __this = this;
            let facetDropdown = this.querySelector(`#${dropdownId}`); 
            const _hpSearchLegacy = __this.isHomepageSearchURL();
            if(facetDropdown){
                facetDropdown.options.length = 0;
                let optFragment = new DocumentFragment();
                let placeholderOpt = document.createElement('option');
                    placeholderOpt.innerText = placeholder
                    placeholderOpt.value = "";
                if (_hpSearchLegacy) {
                    placeholderOpt.className = "disabled";
                    placeholderOpt.disabled = true;
                } else {
                    placeholderOpt.className = "";
                    placeholderOpt.disabled = false;
                }
                    placeholderOpt.selected = true;
                optFragment.appendChild(placeholderOpt);
                if(options.length > 0){
                    for (let index = 0; index < options.length; index++) {
                        let option = options[index];
                        let opt = document.createElement('option');
                        opt.innerText = option.label
                        opt.value = option.value;
                        if(dropdownVal) opt.selected = 'selected';
                        optFragment.appendChild(opt);
                    }
                }
                facetDropdown.append(optFragment);
                if(dropdownVal) {
                    facetDropdown.value = dropdownVal;
                    return;
                }
                if(!isResponseHasPartNumber){
                    facetDropdown.classList.remove("hide");
                    if($(window).width() > 767){
                        const $fd = $(facetDropdown);
                        if ($fd.data('select2')) {
                            $fd.select2('destroy');
                        }
                        const s2opts = {
                            matcher:(params, data) => {
                                return __this._matcher(params, data);
                            },
                            dropdownPosition: 'below'
                        };
                        if (_hpSearchLegacy) {
                            s2opts.selectOnClose = true;
                        }
                        $fd.select2(s2opts);
                    }
                }
                if(dropdownId !== 'termYear' &&
                    dropdownId !== 'termMake' &&
                    dropdownId !== 'termModel' &&
                    __this.hasForceReload === true
                ){
                    isNextDropdownOpen = true;
                }
                if (!_hpSearchLegacy && !dropdownVal && options.length > 0 && !this._facetFetchStopRedirect) {
                    facetDropdown.value = "";
                    if ($(window).width() > 767) {
                        const $fd = $(facetDropdown);
                        if ($fd.data('select2')) {
                            $fd.val("").trigger("change.select2");
                        }
                    }
                }
                if(dropdownId !== "termYear" && options.length > 0 && isNextDropdownOpen == true && $(`#${dropdownId}`).attr("data-select2-id") && $(window).width() > 767){
                    const $openEl = $(`#${dropdownId}`);
                    const openNext = function () {
                        if ($openEl.data('select2')) {
                            $openEl.select2("open");
                        }
                    };
                    if (_hpSearchLegacy) {
                        openNext();
                    } else {
                        setTimeout(openNext, 0);
                    }
                }
            }
        }

        // build options for the dropdowns
        buildOptions(optData, _isQual) {
            // console.log(optData)
            let optionsData = [];
            if(optData.length > 0){
                for (let index = 0; index < optData.length; index++) {
                    let opt = optData[index];
                    if(Object.keys(opt).length > 1){
                        let _tmpObj = {};
                        Object.keys(opt).map((key) => {
                            if(Object.keys(opt).includes('make')){
                                key === "make" ? _tmpObj.label = opt[key] : _tmpObj.value = `${opt['MakeID']}_${opt['make']}`;
                            }
                            else if(Object.keys(opt).includes('model')){
                                key === "model" ? _tmpObj.label = opt[key] : _tmpObj.value = `${opt['BaseVehicleID']}_${opt['model']}`;
                            }
                            else if(Object.keys(opt).includes('engine')){
                                key === "engine" ? _tmpObj.label = opt[key] : _tmpObj.value = `${opt['EngineConfigID']}_${opt['engine']}`;
                            }
                            else if(_isQual == true){
                                key === "values" ? _tmpObj.label = opt[key] : _tmpObj.value = `${opt['id'].replace(':', ';')}_${opt['values']}`;
                            }
                        });
                        optionsData.push(_tmpObj);
                    }else{
                        // checking the type of data get from response and making option data accordingly.
                        if(Object.keys(opt) == "year"){
                            optionsData.push({
                                label: opt.year,
                                value:opt.year
                            });  
                        }
                    }
                }
            }
            return optionsData;
        }
        async getAllQualifiers(CHECK_QUALIFIERS_API){
            let getAllQualifiers = await fetch( CHECK_QUALIFIERS_API ,{
                method:"GET",
                mode:"cors",
            }).then(async response => {
                return await response.json();
            }).then(json => {
                return json;
            });
            return getAllQualifiers;
        }


        // fetch facet data for the given year, make, model, engine, aspiration, region and engine type also check for automatic open next dropdown
        async fetchFacetData(facetFilterAttributes = {}, isNextDropdownOpen = true, stopRedirect = false){
            this._facetFetchStopRedirect = !!stopRedirect;
            try {
            // declaring variables for new APIs that have new URLs.
            let NEW_API_FOR_YEAR = `${API_BASE_URL_NEW}/yearCollection/2`;
            let NEW_API_FOR_MAKE = `${API_BASE_URL}/makeCollection/2`;
            let NEW_API_FOR_MODEL = `${API_BASE_URL}/modelCollection/2`;
            let getPartNumbers = false;
            let __this = this;
            let qualifiersToShow;
            let baseVehicleForPartNumbers;
            this.facetWaitSpinner(true);
            this.searchQuery = "";
            let isQual = false;
            let formData = new FormData();
            let _subQuery = "";
            (Object.keys(facetFilterAttributes).length === 0) ? (
                formData.append("termdummy", "year")
            ) : undefined;

            
            Object.keys(facetFilterAttributes).forEach((key) => {
                facetFilterAttributes[key] && (
                    formData.append(key, facetFilterAttributes[key]),
                    _subQuery+=`${key}:${facetFilterAttributes[key]}|`
                );
                
            });
            // creating a variable that contains new api urls its value changes for year, make and model 
            let NEW_API_URL = NEW_API_FOR_YEAR;
            
            // condition to check and set appropriate url to fetch year make or model

            
            
            if(facetFilterAttributes[this.qualifierName] != undefined){
                // console.log(this.singleEngine);
                const _model = facetFilterAttributes.termModel.split("_");
                const _baseVehicleId = _model[0];
                const _engineID = facetFilterAttributes?.engineBaseId?.split("_");
                let engineID;
                if(_engineID){
                    engineID = _engineID[0];
                }
                else if(this.skipEngine){
                    engineID = this.skipEngine;
                }
                else{
                    engineID = this.singleEngine; 
                }
                const tempMake = facetFilterAttributes.termMake.split('_');
                const tempModel = facetFilterAttributes.termModel.split('_');
                const qualID = encodeURIComponent(facetFilterAttributes[this.qualifierName]?.split('_')[0].replace(';', ':'));
                const qualValue = encodeURIComponent(facetFilterAttributes[this.qualifierName]?.split('_')[1]);
                NEW_API_URL = `${API_BASE_URL_NEW}/productList/${_baseVehicleId}/${engineID}/${qualID}/${qualValue}`;
                getPartNumbers = true;
                baseVehicleForPartNumbers = _baseVehicleId;
                facetFilterAttributes.termMake = tempMake[1];
                facetFilterAttributes.termModel = tempModel[1];
            }
            else if(facetFilterAttributes.engineBaseId != undefined){
                const _model = facetFilterAttributes.termModel.split("_");
                const _baseVehicleId = _model[0];
                const _engineID = facetFilterAttributes.engineBaseId.split("_");
                const engineID = _engineID[0];
                const tempMake = facetFilterAttributes.termMake.split('_');
                const tempModel = facetFilterAttributes.termModel.split('_');
                const CHECK_QUALIFIERS = `${API_BASE_URL}/qualifierCollectionPureFlow/${_baseVehicleId}/${engineID}/noqualifier/0/0`;
                const allQualifiers = await this.getAllQualifiers(CHECK_QUALIFIERS);
                if(allQualifiers?.name?.length == 1 && allQualifiers?.values?.length == 1){
                    NEW_API_URL = `${API_BASE_URL_NEW}/productList1/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                    getPartNumbers = true;
                    baseVehicleForPartNumbers = _baseVehicleId;
                    facetFilterAttributes.termMake = tempMake[1];
                    facetFilterAttributes.termModel = tempModel[1];
                }
                else if(allQualifiers?.name?.length == 1 && allQualifiers?.values?.length > 1 && allQualifiers?.showdropdown == "true"){
                    qualifiersToShow = allQualifiers;
                    isQual = true;
                }
                else if(allQualifiers == "fail"){
                    NEW_API_URL = `${API_BASE_URL_NEW}/productList1/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                    getPartNumbers = true;
                    baseVehicleForPartNumbers = _baseVehicleId;
                    facetFilterAttributes.termMake = tempMake[1];
                    facetFilterAttributes.termModel = tempModel[1];
                }
                // NEW_API_URL = `${API_BASE_URL}/productList/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                // getPartNumbers = true;
                // baseVehicleForPartNumbers = _baseVehicleId;
                // facetFilterAttributes.baseVehicleId = _baseVehicleId;
                // facetFilterAttributes.engineBaseId = engineID;
                // facetFilterAttributes.termMake = tempMake[1];
                // facetFilterAttributes.termModel = tempModel[1];
            }
            else if(facetFilterAttributes.termModel != undefined){
                const _model = facetFilterAttributes.termModel.split("_");
                const _baseVehicleId = _model[0];
                let NEW_API_FOR_ENGINE = `${API_BASE_URL}/engineCollection/${_baseVehicleId}`;

                let getEngineData = await fetch( NEW_API_FOR_ENGINE ,{
                    method:"GET",
                    mode:"cors",
                }).then(async response => {
                    return await response.json();
                }).then(json => {
                    return json;
                });

                if(getEngineData.length == 1){
                    const engineID = getEngineData[0].EngineConfigID;
                    this.singleEngine = getEngineData[0].EngineConfigID;
                    const tempMake = facetFilterAttributes.termMake.split('_');
                    const tempModel = facetFilterAttributes.termModel.split('_');
                    const CHECK_QUALIFIERS = `${API_BASE_URL}/qualifierCollectionPureFlow/${_baseVehicleId}/${engineID}/noqualifier/0/0`;
                    const allQualifiers = await this.getAllQualifiers(CHECK_QUALIFIERS);
                    if(allQualifiers?.name?.length == 1 && allQualifiers?.values?.length == 1){
                        NEW_API_URL = `${API_BASE_URL_NEW}/productList1/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                        getPartNumbers = true;
                        baseVehicleForPartNumbers = _baseVehicleId;
                        facetFilterAttributes.termMake = tempMake[1];
                        facetFilterAttributes.termModel = tempModel[1];
                    }
                    else if(allQualifiers.name?.length == 1 && allQualifiers?.values?.length > 1 && allQualifiers?.showdropdown == "true"){
                        qualifiersToShow = allQualifiers;
                        isQual = true;
                    }
                    else if(allQualifiers == "fail"){
                        NEW_API_URL = `${API_BASE_URL_NEW}/productList1/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                        getPartNumbers = true;
                        baseVehicleForPartNumbers = _baseVehicleId;
                        facetFilterAttributes.termMake = tempMake[1];
                        facetFilterAttributes.termModel = tempModel[1];
                    }
                    // NEW_API_URL = `${API_BASE_URL}/productList/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                    // getPartNumbers = true;
                    // baseVehicleForPartNumbers = _baseVehicleId;
                    // facetFilterAttributes.termMake = tempMake[1];
                    // facetFilterAttributes.termModel = tempModel[1];
                }
                else{
                    let CHECK_ENGINE_API = `${API_BASE_URL}/engineCheckPureFlow/${_baseVehicleId}`;
                    let checkEngineData = await fetch( CHECK_ENGINE_API ,{
                        method:"GET",
                        mode:"cors",
                    }).then(async response => {
                        return await response.json();
                    }).then(json => {
                        return json;
                    });
                    let showEngine = checkEngineData[checkEngineData.length - 1];

                    if(showEngine.showdropdown == "false"){
                        const engineID = getEngineData[0].EngineConfigID;
                        const tempMake = facetFilterAttributes.termMake.split('_');
                        const tempModel = facetFilterAttributes.termModel.split('_');
                        const CHECK_QUALIFIERS = `${API_BASE_URL}/qualifierCollectionPureFlow/${_baseVehicleId}/${engineID}/noqualifier/0/0`;
                        const allQualifiers = await this.getAllQualifiers(CHECK_QUALIFIERS);
                        if(allQualifiers?.name?.length == 1 && allQualifiers?.values?.length == 1){
                            NEW_API_URL = `${API_BASE_URL_NEW}/productList1/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                            getPartNumbers = true;
                            baseVehicleForPartNumbers = _baseVehicleId;
                            facetFilterAttributes.termMake = tempMake[1];
                            facetFilterAttributes.termModel = tempModel[1];
                        }
                        else if(allQualifiers.name?.length == 1 && allQualifiers?.values?.length > 1 && allQualifiers?.showdropdown == "true"){
                            qualifiersToShow = allQualifiers;
                            isQual = true;
                            this.skipEngine = engineID;
                        }
                        else if(allQualifiers == "fail"){
                            NEW_API_URL = `${API_BASE_URL_NEW}/productList1/${_baseVehicleId}/${engineID}/noqualifier/noqualifier`;
                            getPartNumbers = true;
                            baseVehicleForPartNumbers = _baseVehicleId;
                            facetFilterAttributes.termMake = tempMake[1];
                            facetFilterAttributes.termModel = tempModel[1];
                        }
                    }
                    else{
                        NEW_API_URL = `${API_BASE_URL}/engineCollection/${_baseVehicleId}`;
                    }
                }

            }
            else if(facetFilterAttributes.termMake != undefined){
                const _make = facetFilterAttributes.termMake.split("_");
                const makeId = _make[0];

                NEW_API_URL = `${NEW_API_FOR_MODEL}/${facetFilterAttributes.termYear}/${makeId}`;
            }
            else if(facetFilterAttributes.termYear != undefined){
                NEW_API_URL = `${NEW_API_FOR_MAKE}/${facetFilterAttributes.termYear}`;
            }
            
            let _apiRes = await fetch( NEW_API_URL ,{
                method:"GET",
                mode:"cors",
            }).then(async response => {
                return await response.json();
            }).then(json => {
                return json;
            });

            // redeclaring the default response variable.
            let apiRes = {};
            // storing the res of new api to default variable with key response
            if(qualifiersToShow != null){
                _apiRes = qualifiersToShow.values;
                // console.log(qualifiersToShow.name[0]);
            }
            apiRes.response = _apiRes;
            // not getting names, so setting names for API response in default variable
            if(facetFilterAttributes.termModel != undefined){
                apiRes.name = "engine";
            }
            else if(facetFilterAttributes.termMake != undefined){
                apiRes.name = "model";
            }
            else if(facetFilterAttributes.termYear != undefined){
                apiRes.name = "make";
            }

            if(qualifiersToShow != null){
                const _nameForQual = qualifiersToShow.values[0].id.split(":");
                apiRes.name = _nameForQual[0];
                this.qualifierName = _nameForQual[0];
            }
            // uncomment later
            if(getPartNumbers == true){
                
                const filteredPartTypeArray = _apiRes.partTypeArray.filter(item => {
                    const noteMatch = item?.note?.toLowerCase().includes("pureflow");
                    const partNumberMatch = item?.partNumber?.toUpperCase().startsWith("RZ");
                    return noteMatch || partNumberMatch;
                });

                const allPartTypeArray = [].concat(filteredPartTypeArray);
                apiRes.response = allPartTypeArray;
                apiRes.name = "part_numbers";
                apiRes.baseVehicleId = baseVehicleForPartNumbers;
            }
            
            // console.log(apiRes);
            let isResponseHasPartNumber = apiRes.response.filter((item) => {
                return item.partNumber ? true : false;
            }).length > 0;

            let _optData = apiRes.response || [];

            // added fix for NRC products
            if(_optData.length === 1) {
                if(_optData[0].partNumber == 'NRC' || _optData[0].partNumber == 'NR' ) {
                    // if(!stopRedirect) window.location.href = `/pages/not-required`;
                    this.facetWaitSpinner(false);
                    window.location.href = `/pages/not-required`;
                    return stopRedirect ? apiRes : undefined;
                }
            }
            // added fix for NA products end
            if(_optData.length === 0) {
                localStorage.setItem("selectedModel",facetFilterAttributes?.termModel);
                localStorage.setItem("selectedMake",facetFilterAttributes?.termMake);
                localStorage.setItem("selectedYear",facetFilterAttributes?.termYear);
                this.facetWaitSpinner(false);
                if(!stopRedirect) window.location.href = `/pages/not-available-in-pureflow`;
                return stopRedirect ? apiRes : undefined;
            };

            _optData = this.buildOptions(_optData, isQual);
            // console.log("_optData", _optData)
             // add baseVehicleId into hidden input field
            let baseVehicleIdSelector = this.querySelector("#baseVehicleId");    
            apiRes.baseVehicleId && baseVehicleIdSelector && apiRes?.baseVehicleId && (
                baseVehicleIdSelector.value = apiRes.baseVehicleId || "N/A"
            );
            
            if(Object.keys(facetFilterAttributes).length === 0){
                this.fillDropdown("termYear",_optData, "Vehicle Year", isResponseHasPartNumber, isNextDropdownOpen);
            }else if(apiRes?.length !== 0 && !isResponseHasPartNumber){
                if(!YMM_ATTRIBUTES[apiRes?.name]){
                    const facetsEntries = Object.entries(FACETS_ATTRIBUTES).filter(facet => {
                        return apiRes[facet[1]]
                    });
                    if(facetsEntries.length){
                        facetsEntries.forEach(facet => {
                            const tempId = facet[0];
                            const key = facet[1];
                            const hasDropdown = document.querySelector(`#${key}`);
                            if(!key || hasDropdown || !apiRes[key]) return;
                            let tempVal = apiRes[key];
                            tempVal = tempVal.replaceAll('\'','');
                            this.createDropdown(tempId, tempVal);
                            this.fillDropdown(FACETS_ATTRIBUTES[tempId],[{label: tempId, value: tempVal}],`Vehicle ${this._capitalize(tempId)}`, isResponseHasPartNumber, isNextDropdownOpen, tempVal);
                        });
                    }

                    this.createDropdown(apiRes?.name);
                }
                // !YMM_ATTRIBUTES[apiRes?.name] && this.createDropdown(apiRes?.name, apiRes?.engineBaseId);
                
                if(apiRes?.name === "engine" && !apiRes?.engineBaseId){
                    this.fillDropdown(FACETS_ATTRIBUTES[apiRes?.name],_optData,`Vehicle ${this._capitalize(apiRes?.name)}`, isResponseHasPartNumber, isNextDropdownOpen);
                }else if(this.querySelector(`#${YMM_ATTRIBUTES[apiRes?.name] || apiRes?.name}`)){
                    this.fillDropdown(YMM_ATTRIBUTES[apiRes?.name] || apiRes?.name,_optData, YMM_ATTRIBUTES[apiRes?.name] ? `Vehicle ${this._capitalize(apiRes?.name)}` : this._capitalize(FACETS_ATTRIBUTES[apiRes?.name]), isResponseHasPartNumber, isNextDropdownOpen);
                }
            }
            if(isResponseHasPartNumber && apiRes?.response?.length > 0){
                let _products = apiRes?.response?.map((opt) => {
                    return opt.partNumber;
                });
                if(_products.length === 0) { 
                    return;
                }
                
                let formDataProduct = new FormData();
                formDataProduct.append("termYear", facetFilterAttributes?.termYear || "");
                formDataProduct.append("termMake", facetFilterAttributes?.termMake || "");
                formDataProduct.append("termModel", facetFilterAttributes?.termModel || "");
                formDataProduct.append("partNumber", _products.join(","));
                if(window.location.href.includes("brand=febreze")){
                    formDataProduct.append("brand", "febreze");
                }
                let productHandles;
                try {
                    const productResponse = await fetch(API_PRODUCT_BASE_URL,{
                        method:"POST",
                        mode:"cors",
                        body:formDataProduct
                    });
                    if (!productResponse.ok) {
                        throw new Error(`getProducts HTTP error! status: ${productResponse.status}`);
                    }
                    productHandles = await productResponse.json();
                } catch (productError) {
                    console.error('getProducts API failed:', productError);
                    localStorage.setItem("selectedModel",facetFilterAttributes?.termModel);
                    localStorage.setItem("selectedMake",facetFilterAttributes?.termMake);
                    localStorage.setItem("selectedYear",facetFilterAttributes?.termYear);
                    this.facetWaitSpinner(false);
                    if(!stopRedirect) window.location.href = `/pages/not-available-in-pureflow`;
                    return stopRedirect ? apiRes : undefined;
                }

                if(!productHandles?.response || productHandles.response.length === 0){
                    localStorage.setItem("selectedModel",facetFilterAttributes?.termModel);
                    localStorage.setItem("selectedMake",facetFilterAttributes?.termMake);
                    localStorage.setItem("selectedYear",facetFilterAttributes?.termYear);
                    if(!stopRedirect) window.location.href = `/pages/not-available-in-pureflow`; //added for 11jun fix
                    return stopRedirect ? apiRes : undefined;
                }
                let _handles = productHandles.response.map((product) => {
                    return product.handle;
                });
                this.isFilterApply = true;
                this.hasForceReload === true ? (
                    isNextDropdownOpen = true
                ) : (
                    isNextDropdownOpen = isNextDropdownOpen
                );

                // _handles.sort((a, b) => {
                //     const hasHepaA = a.includes("hepa");
                //     const hasHepaB = b.includes("hepa");
                
                //     if (hasHepaA && !hasHepaB) return 1;  
                //     if (!hasHepaA && hasHepaB) return -1;
                //     return 0; 
                // });

                // document.querySelector('.dummy-heading').innerHTML = _handles.join(" OR handle:")

                let febrezeQuery = "";
                if(window.location.href.includes("brand=febreze")) {
                    febrezeQuery = `&brand=febreze`;
                }

                this.searchQuery = `/search?type=product&q=(handle:${_handles.join(" OR handle:")})&filter=carair@advance-filter=${_subQuery.slice(0,-1)}${febrezeQuery}&sort_by=price-descending`;
                if(isNextDropdownOpen === true){
                    var advancedCarFilter_check = window.location.search.includes("homepageSearch");
                    if(!advancedCarFilter_check){
                        Shopify?.analytics?.publish("on_advance_car_filters", {
                            vehicle_year: facetFilterAttributes?.termYear,
                            vehicle_make: facetFilterAttributes?.termMake,
                            vehicle_model: facetFilterAttributes?.termModel
                        });
                    }
                    this.facetWaitSpinner(false);
                    window.location.href = this.searchQuery;
                }
            }
            setTimeout(() => {
                __this.facetWaitSpinner(false);
            },200);
            if(isNextDropdownOpen === false){
                return {"success":true}
            }
            } catch (error) {
                console.error('fetchFacetData API failed:', error);
                this.facetWaitSpinner(false);
                // Redirect when product lookup fails (model selected or part-number stage)
                const hasVehicleSelection = !!(facetFilterAttributes?.termModel || facetFilterAttributes?.termMake);
                if (!stopRedirect && hasVehicleSelection) {
                    localStorage.setItem("selectedModel", facetFilterAttributes?.termModel || "");
                    localStorage.setItem("selectedMake", facetFilterAttributes?.termMake || "");
                    localStorage.setItem("selectedYear", facetFilterAttributes?.termYear || "");
                    window.location.href = `/pages/not-available-in-pureflow`;
                }
            } finally {
                this._facetFetchStopRedirect = false;
            }
        }
        
        getHomeCollectionConfig() {
            return window.FACET_FILTER?.homeCollection || {
                handle: 'home-furnace-air-filter',
                lookupSection: 'home-filter-lookup',
                collectionSection: 'main-collection-products',
                collectionView: 'hvac-new',
            };
        }

        _appendHomeFilterParams(url, activeParams = {}) {
            Object.keys(activeParams).forEach((key) => {
                if (activeParams[key]) {
                    url.searchParams.set(key, activeParams[key]);
                }
            });
        }

        _parseFiltersFromMcpPanel(root) {
            if (!root) return null;

            const panel = root.matches?.('[data-mcp-filters-panel="desktop-top"]')
                ? root
                : root.querySelector('[data-mcp-filters-panel="desktop-top"]');
            if (!panel) return null;

            const filters = [];
            panel.querySelectorAll('[data-mcp-filter-dropdown]').forEach((dropdown) => {
                const paramName = dropdown.getAttribute('data-mcp-filter-group') || '';
                const label = dropdown.querySelector('.mcp-filter-dropdown__label')?.textContent?.trim() || '';
                const values = [];

                dropdown.querySelectorAll('[data-mcp-filter-input]').forEach((input) => {
                    const labelEl = input.closest('.mcp-tag-checkbox-label');
                    const countText = labelEl?.querySelector('.mcp-tag-count')?.textContent || '';
                    const countMatch = countText.match(/\d+/);
                    const displayText = labelEl?.querySelector('.mcp-tag-label')?.childNodes?.[0]?.textContent?.trim() || '';
                    const numericValue = this._extractHomeFilterNumeric({ value: input.value, label: input.value, numeric: displayText });
                    const isDisabled = input.disabled || labelEl?.classList.contains('is-disabled');
                    const count = countMatch ? parseInt(countMatch[0], 10) : 0;

                    values.push({
                        value: input.value,
                        label: input.value,
                        numeric: numericValue,
                        count,
                        active: input.checked,
                        disabled: isDisabled,
                    });
                });

                filters.push({
                    label,
                    param_name: paramName,
                    values,
                });
            });

            return filters.length ? { filters } : null;
        }

        _parseFiltersFromMcpHtml(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const root = doc.querySelector('[data-home-filter-lookup]') || doc;
            const filterData = this._parseFiltersFromMcpPanel(root);
            return filterData?.filters?.length ? this._normalizeHomeFilterRoles(filterData) : null;
        }

        _getHomeFilterFromPagePanel() {
            const source = document.getElementById('home-filter-lookup-source');
            if (!source) return null;
            const filterData = this._parseFiltersFromMcpPanel(source);
            return filterData?.filters?.length ? this._normalizeHomeFilterRoles(filterData) : null;
        }

        _buildShopifyCollectionFilterUrl(cfg, activeParams = {}, sectionKey = '') {
            const url = new URL(`${window.location.origin}/collections/${cfg.handle}`);
            if (cfg.collectionView) {
                url.searchParams.set('view', cfg.collectionView);
            }
            if (sectionKey) {
                url.searchParams.set('sections', sectionKey);
            }
            this._appendHomeFilterParams(url, activeParams);
            return url;
        }

        async _fetchShopifyCollectionFilterSection(cfg, activeParams = {}, sectionKey) {
            const url = this._buildShopifyCollectionFilterUrl(cfg, activeParams, sectionKey);
            const response = await fetch(url.toString(), {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
            if (!response.ok) {
                throw new Error(`Shopify collection filter section fetch failed: ${response.status}`);
            }

            const payload = await response.json();
            const sectionHtml = payload?.[sectionKey];
            if (!sectionHtml) {
                throw new Error(`Shopify collection filter section "${sectionKey}" missing from response`);
            }

            const filterData = this._parseFiltersFromMcpHtml(sectionHtml);
            if (!filterData?.filters?.length) {
                throw new Error('Shopify collection filter section missing MCP filters');
            }

            return { filterData, sectionHtml };
        }

        _syncHomeFilterLookupSource(sectionHtml) {
            if (!sectionHtml) return;
            const source = document.getElementById('home-filter-lookup-source');
            if (!source) return;

            const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const nextPanel = doc.querySelector('[data-mcp-filters-panel="desktop-top"]');
            const currentPanel = source.querySelector('[data-mcp-filters-panel="desktop-top"]');
            if (nextPanel && currentPanel) {
                currentPanel.innerHTML = nextPanel.innerHTML;
            }
        }

        _homePagePanelHasNumericOptions(pageData, role = 'depth') {
            const filter = this._getHomeFilterByRole(pageData, role);
            return this._getHomeFilterNumericOptions(filter).length > 0;
        }

        async fetchHomeCollectionFilterData(activeParams = {}) {
            const cfg = this.getHomeCollectionConfig();
            const isIndexPage = document.body.classList.contains('template-index');

            if (!isIndexPage && Object.keys(activeParams).length === 0) {
                const pageData = this._getHomeFilterFromPagePanel();
                if (pageData?.filters?.length && this._homePagePanelHasNumericOptions(pageData, 'depth')) {
                    return pageData;
                }
            }

            const sectionKeys = [
                cfg.lookupSection || 'home-filter-lookup',
                cfg.collectionSection || 'main-collection-products',
            ].filter((value, index, list) => value && list.indexOf(value) === index);

            let lastError = null;
            for (const sectionKey of sectionKeys) {
                try {
                    const { filterData, sectionHtml } = await this._fetchShopifyCollectionFilterSection(cfg, activeParams, sectionKey);
                    if (Object.keys(activeParams).length > 0) {
                        this._syncHomeFilterLookupSource(sectionHtml);
                    }
                    return filterData;
                } catch (error) {
                    lastError = error;
                }
            }

            throw lastError || new Error('Shopify collection filter fetch failed');
        }

        _normalizeHomeFilterRoles(filterData) {
            if (!filterData?.filters) return filterData;

            filterData.filters.forEach((filter) => {
                if (filter.role) return;

                const param = String(filter.param_name || '').toLowerCase();
                const label = String(filter.label || '').toLowerCase();

                if (param.includes('filter_width') || label.includes('width')) {
                    filter.role = 'width';
                } else if (param.includes('custom.length') || label.includes('length') || label.includes('height')) {
                    filter.role = 'length';
                } else if (param.includes('custom.thickness') || label.includes('thickness') || label.includes('depth')) {
                    filter.role = 'depth';
                } else if (filter.values?.length) {
                    const sample = String(filter.values[0].label || filter.values[0].value || '').toUpperCase();
                    if (sample.includes('WIDTH_')) filter.role = 'width';
                    else if (sample.includes('HEIGHT_')) filter.role = 'length';
                    else if (sample.includes('DEPTH_')) filter.role = 'depth';
                }
            });

            return filterData;
        }

        _getHomeFilterByRole(filterData, role) {
            if (!filterData?.filters) return null;
            return filterData.filters.find((filter) => filter.role === role) || null;
        }

        _sanitizeHomeFilterNumericString(value) {
            return String(value || '')
                .split('_')
                .pop()
                .replace(/&quot;/gi, '')
                .replace(/"/g, '')
                .trim();
        }

        _extractHomeFilterNumeric(entry) {
            if (entry?.numeric != null && entry.numeric !== '') {
                const fromNumeric = parseFloat(this._sanitizeHomeFilterNumericString(entry.numeric));
                if (Number.isFinite(fromNumeric)) return fromNumeric;
            }

            const raw = entry?.value ?? entry?.label ?? '';
            const normalized = this._sanitizeHomeFilterNumericString(raw);
            const numeric = parseFloat(normalized);
            return Number.isFinite(numeric) ? numeric : null;
        }

        _buildHomeFilterParamValue(role, numeric) {
            const prefix = role === 'width' ? 'Width' : role === 'length' ? 'Height' : 'Depth';
            return `${prefix}_${numeric}"`;
        }

        _getHomeFilterParamName(filterData, role) {
            const filter = this._getHomeFilterByRole(filterData, role);
            if (filter?.param_name) return filter.param_name;

            const defaults = {
                depth: 'filter.p.m.custom.thickness',
                width: 'filter.p.m.custom.filter_width',
                length: 'filter.p.m.custom.length',
            };
            return defaults[role] || null;
        }

        _redirectToHomeSearchIfNeeded(isNextDropdownOpen = true) {
            if (this.homeSearchQuery === '' || isNextDropdownOpen !== true) return;

            const nextParams = new URLSearchParams(this.homeSearchQuery.split('?')[1] || '');
            const nextQuery = nextParams.get('q') || '';
            const currentQuery = new URLSearchParams(window.location.search).get('q') || '';

            if (currentQuery === nextQuery && window.location.pathname === '/search') {
                this._clearHomeFilterErrorOnResultsPage();
                return;
            }

            if (!window.location.search.includes('homepageSearch')) {
                const parts = nextQuery.split(',');
                Shopify?.analytics?.publish('on_advanced_home_filters', {
                    filterWidth: parts[1]?.replace('Width_', '') || '',
                    filterLength: parts[2]?.replace('Height_', '') || '',
                    filterDepth: parts[3]?.replace('Depth_', '') || ''
                });
            }
            window.location.href = `${this.homeSearchQuery}#hometab2`;
        }

        _getHomeFilterNumericOptions(filter) {
            if (!filter?.values?.length) return [];
            const nums = new Set();

            filter.values.forEach((entry) => {
                const numeric = this._extractHomeFilterNumeric(entry);
                if (!Number.isFinite(numeric)) return;
                if (entry.disabled) return;
                if (Number(entry.count) <= 0 && !entry.active) return;
                nums.add(numeric);
            });

            return Array.from(nums).sort((a, b) => a - b);
        }

        _getFilterParamForNumeric(filterData, role, numeric) {
            const filter = this._getHomeFilterByRole(filterData, role);
            const paramName = filter?.param_name || this._getHomeFilterParamName(filterData, role);
            if (!paramName) return null;

            const target = parseFloat(numeric);
            const match = filter?.values?.find((entry) => this._extractHomeFilterNumeric(entry) === target);
            if (match?.value) {
                return { param_name: paramName, value: match.value };
            }

            if (!Number.isFinite(target)) return null;
            return {
                param_name: paramName,
                value: this._buildHomeFilterParamValue(role, target),
            };
        }

        _setHomeActiveFilterParam(activeParams, filterData, role, numeric) {
            if (!numeric) return;
            const param = this._getFilterParamForNumeric(filterData, role, numeric);
            if (param) {
                activeParams[param.param_name] = param.value;
            }
        }

        _buildHomeActiveFilterParams(filterThickness, filterWidth, filterLength, filterData) {
            const params = {};
            const depthParam = filterThickness ? this._getFilterParamForNumeric(filterData, 'depth', filterThickness) : null;
            const widthParam = filterWidth ? this._getFilterParamForNumeric(filterData, 'width', filterWidth) : null;
            const lengthParam = filterLength ? this._getFilterParamForNumeric(filterData, 'length', filterLength) : null;

            if (depthParam) params[depthParam.param_name] = depthParam.value;
            if (widthParam) params[widthParam.param_name] = widthParam.value;
            if (lengthParam) params[lengthParam.param_name] = lengthParam.value;

            return params;
        }

        _getHomeSelectElement(dropdownId, root = null) {
            if (!root || root === this) {
                return this.querySelector(`#${dropdownId}`);
            }
            return root.querySelector(`#${dropdownId}`) || document.getElementById(dropdownId);
        }

        _getExternalHomeSelectIds(external) {
            return external?.selectIds || {
                depth: 'searchDepth',
                width: 'searchWidth',
                length: 'searchHeight',
            };
        }

        getHomeFilterCombos() {
            return Array.isArray(window.FACET_FILTER?.homeFilterCombos)
                ? window.FACET_FILTER.homeFilterCombos
                : [];
        }

        _uniqueSortedHomeNumbers(values) {
            const nums = new Set();
            values.forEach((value) => {
                const numeric = parseFloat(value);
                if (Number.isFinite(numeric) && numeric > 0) {
                    nums.add(numeric);
                }
            });
            return Array.from(nums).sort((a, b) => a - b);
        }

        fetchHomeDataFromCombos(filterThickness = '', filterWidth = '', filterLength = '', isNextDropdownOpen = true, suppressImprovedBlankReset = false, external = null) {
            const combos = this.getHomeFilterCombos();
            if (!combos.length) {
                return false;
            }

            const externalRoot = external?.root || null;
            const selectIds = this._getExternalHomeSelectIds(external);
            const fillHomeSelect = (role, options, placeholder, openNext) => {
                this.fillHomeDropdown(
                    selectIds[role],
                    options,
                    placeholder,
                    openNext,
                    suppressImprovedBlankReset,
                    externalRoot
                );
            };

            if (!filterThickness && !filterWidth && !filterLength) {
                fillHomeSelect(
                    'depth',
                    this._uniqueSortedHomeNumbers(combos.map((combo) => combo.depth)),
                    'Filter Thickness',
                    isNextDropdownOpen
                );
                return true;
            }

            if (filterThickness && !filterWidth && !filterLength) {
                fillHomeSelect(
                    'width',
                    this._uniqueSortedHomeNumbers(
                        combos
                            .filter((combo) => parseFloat(combo.depth) === parseFloat(filterThickness))
                            .map((combo) => combo.width)
                    ),
                    'Filter Width',
                    isNextDropdownOpen
                );
                return true;
            }

            if (filterThickness && filterWidth && !filterLength) {
                fillHomeSelect(
                    'length',
                    this._uniqueSortedHomeNumbers(
                        combos
                            .filter((combo) => (
                                parseFloat(combo.depth) === parseFloat(filterThickness)
                                && parseFloat(combo.width) === parseFloat(filterWidth)
                            ))
                            .map((combo) => combo.length)
                    ),
                    'Filter Length',
                    isNextDropdownOpen
                );
                return true;
            }

            if (filterThickness && filterWidth && filterLength) {
                const searchUrl = `/search?q=hvac,Width_${filterWidth},Height_${filterLength},Depth_${filterThickness}`;
                if (external?.onComplete) {
                    external.onComplete(searchUrl);
                    return true;
                }
                this.isHomeFilterApply = true;
                this.homeSearchQuery = searchUrl;
                this._redirectToHomeSearchIfNeeded(isNextDropdownOpen);
                return true;
            }

            return false;
        }

        _shouldPreferHomeFilterCombos(external) {
            return document.body.classList.contains('template-index') && !external;
        }

        // fetch home filter data from home-furnace-air-filter collection filters (same source as hvac-new collection page)
        async fetchHomeData(filterThickness = '', filterWidth = '', filterLength = '', isNextDropdownOpen = true, suppressImprovedBlankReset = false, external = null) {
            if (this._shouldPreferHomeFilterCombos(external) && this.getHomeFilterCombos().length > 0) {
                this.fetchHomeDataFromCombos(filterThickness, filterWidth, filterLength, isNextDropdownOpen, suppressImprovedBlankReset, external);
                return;
            }

            const requestId = (this._homeFilterRequestId = (this._homeFilterRequestId || 0) + 1);
            const externalRoot = external?.root || null;
            const selectIds = this._getExternalHomeSelectIds(external);
            const fillHomeSelect = (role, options, placeholder, openNext) => {
                this.fillHomeDropdown(
                    selectIds[role],
                    options,
                    placeholder,
                    openNext,
                    suppressImprovedBlankReset,
                    externalRoot
                );
            };

            try {
                let activeParams = {};
                const baseData = await this.fetchHomeCollectionFilterData();
                if (requestId !== this._homeFilterRequestId) return;

                this._setHomeActiveFilterParam(activeParams, baseData, 'depth', filterThickness);

                if (filterThickness && filterWidth) {
                    const thicknessOnlyData = await this.fetchHomeCollectionFilterData(activeParams);
                    if (requestId !== this._homeFilterRequestId) return;
                    this._setHomeActiveFilterParam(activeParams, thicknessOnlyData, 'width', filterWidth);
                }

                const filterData = Object.keys(activeParams).length
                    ? await this.fetchHomeCollectionFilterData(activeParams)
                    : baseData;
                if (requestId !== this._homeFilterRequestId) return;
                this._homeFilterCache = filterData;

                if (!filterThickness && !filterWidth && !filterLength) {
                    const depthFilter = this._getHomeFilterByRole(filterData, 'depth');
                    const depthOptions = this._getHomeFilterNumericOptions(depthFilter);
                    if (!depthOptions.length && this.fetchHomeDataFromCombos(filterThickness, filterWidth, filterLength, isNextDropdownOpen, suppressImprovedBlankReset, external)) {
                        return;
                    }
                    fillHomeSelect('depth', depthOptions, 'Filter Thickness', isNextDropdownOpen);
                    return;
                }

                if (filterThickness && !filterWidth && !filterLength) {
                    const widthFilter = this._getHomeFilterByRole(filterData, 'width');
                    const widthOptions = this._getHomeFilterNumericOptions(widthFilter);
                    if (!widthOptions.length && this.fetchHomeDataFromCombos(filterThickness, filterWidth, filterLength, isNextDropdownOpen, suppressImprovedBlankReset, external)) {
                        return;
                    }
                    fillHomeSelect('width', widthOptions, 'Filter Width', isNextDropdownOpen);
                    return;
                }

                if (filterThickness && filterWidth && !filterLength) {
                    const lengthFilter = this._getHomeFilterByRole(filterData, 'length');
                    const lengthOptions = this._getHomeFilterNumericOptions(lengthFilter);
                    if (!lengthOptions.length && this.fetchHomeDataFromCombos(filterThickness, filterWidth, filterLength, isNextDropdownOpen, suppressImprovedBlankReset, external)) {
                        return;
                    }
                    fillHomeSelect('length', lengthOptions, 'Filter Length', isNextDropdownOpen);
                    return;
                }

                if (filterThickness && filterWidth && filterLength) {
                    const searchUrl = `/search?q=hvac,Width_${filterWidth},Height_${filterLength},Depth_${filterThickness}`;
                    if (external?.onComplete) {
                        external.onComplete(searchUrl);
                        return;
                    }
                    this.isHomeFilterApply = true;
                    this.homeSearchQuery = searchUrl;
                    this._redirectToHomeSearchIfNeeded(isNextDropdownOpen);
                }
            } catch (error) {
                if (requestId !== this._homeFilterRequestId) return;
                console.error('fetchHomeData:', error);
                if (this.fetchHomeDataFromCombos(filterThickness, filterWidth, filterLength, isNextDropdownOpen, suppressImprovedBlankReset, external)) {
                    return;
                }
            }
        }

        _isExternalHomeTabActive(root) {
            if (root.querySelector('.homeairtab.active')) {
                return true;
            }
            const tabButtons = root.querySelectorAll('.tab-item-button');
            if (tabButtons.length >= 2 && tabButtons[1].classList.contains('active')) {
                return true;
            }
            const homeContent = root.querySelector('.home-filter-search');
            return Boolean(homeContent && homeContent.style.display === 'flex');
        }

        _externalHomeFilterHasAnySelection(external = {}) {
            const root = external.root || document;
            const selectIds = this._getExternalHomeSelectIds(external);
            return ['depth', 'width', 'length'].some((role) => {
                const el = this._getHomeSelectElement(selectIds[role], root);
                return Boolean(el?.value);
            });
        }

        _updateExternalHomeFilterClearAllVisibility(external = {}) {
            const root = external.root || document;
            const clearBtn = root.querySelector('[data-home-filter-clear-all]');
            if (!clearBtn) return;

            const showClear = this._isExternalHomeTabActive(root)
                && this._externalHomeFilterHasAnySelection(external);

            clearBtn.classList.toggle('facet-home-filter-clear--hidden', !showClear);
            clearBtn.hidden = !showClear;
            clearBtn.disabled = !showClear;
        }

        _clearExternalHomeFilters(external = {}) {
            const root = external.root || document;
            const selectIds = this._getExternalHomeSelectIds(external);

            ['depth', 'width', 'length'].forEach((role) => {
                const el = this._getHomeSelectElement(selectIds[role], root);
                if (!el) return;
                el.value = '';
                const $el = $(el);
                if ($el.data('select2')) {
                    $el.val('').trigger('change.select2');
                }
            });

            this.fillHomeDropdown(selectIds.width, [], 'Filter Width', false, false, root);
            this.fillHomeDropdown(selectIds.length, [], 'Filter Length', false, false, root);
            external.onLoading?.(true);
            return Promise.resolve(this.fetchHomeData('', '', '', false, false, external))
                .finally(() => {
                    external.onLoading?.(false);
                    this._updateExternalHomeFilterClearAllVisibility(external);
                });
        }

        initExternalHomeFilters(external = {}) {
            const __this = this;
            const root = external.root || document;
            const selectIds = this._getExternalHomeSelectIds(external);
            const getSelect = (role) => __this._getHomeSelectElement(selectIds[role], root);

            if ($(window).width() > 767) {
                __this.fillHomeDropdown(selectIds.width, [], 'Filter Width', false, false, root);
                __this.fillHomeDropdown(selectIds.length, [], 'Filter Length', false, false, root);
            }

            const handleHomeChange = (facetRole) => () => {
                external.onLoading?.(true);
                let searchDepth = getSelect('depth')?.value || '';
                let searchWidth = getSelect('width')?.value || '';
                let searchHeight = getSelect('length')?.value || '';

                if (facetRole === 'depth') {
                    searchWidth = '';
                    searchHeight = '';
                    __this.fillHomeDropdown(selectIds.width, [], 'Filter Width', false, false, root);
                    __this.fillHomeDropdown(selectIds.length, [], 'Filter Length', false, false, root);
                } else if (facetRole === 'width') {
                    searchHeight = '';
                    __this.fillHomeDropdown(selectIds.length, [], 'Filter Length', false, false, root);
                }

                __this.fetchHomeData(searchDepth, searchWidth, searchHeight, true, false, external)
                    .finally(() => {
                        external.onLoading?.(false);
                        __this._updateExternalHomeFilterClearAllVisibility(external);
                    });
            };

            ['depth', 'width', 'length'].forEach((role) => {
                const el = getSelect(role);
                if (!el) return;
                const $el = $(el);
                $el.off('.externalHomeFilter');
                if ($(window).width() < 767) {
                    el.addEventListener('change', handleHomeChange(role));
                } else {
                    $el.on('select2:select.externalHomeFilter', handleHomeChange(role));
                }
            });

            root.querySelectorAll('.tab-item-button').forEach((btn) => {
                btn.addEventListener('click', () => {
                    window.setTimeout(() => __this._updateExternalHomeFilterClearAllVisibility(external), 0);
                });
            });

            const clearBtn = root.querySelector('[data-home-filter-clear-all]');
            if (clearBtn && clearBtn.dataset.heroClearBound !== 'true') {
                clearBtn.dataset.heroClearBound = 'true';
                clearBtn.addEventListener('click', (event) => {
                    event.preventDefault();
                    __this._clearExternalHomeFilters(external);
                });
            }

            external.onLoading?.(true);
            return this.fetchHomeData('', '', '', false, false, external)
                .finally(() => {
                    external.onLoading?.(false);
                    __this._updateExternalHomeFilterClearAllVisibility(external);
                });
        }

        // fill home filter dropdown
        fillHomeDropdown(dropdownId, options, placeholder, isNextDropdownOpen = false, suppressImprovedBlankReset = false, root = null){
            let __this = this;
            const isExternalRoot = Boolean(root);
            const _hpSearchLegacy = isExternalRoot ? false : __this.isHomepageSearchURL();
            let facetDropdown = this._getHomeSelectElement(dropdownId, root); 
            if(facetDropdown){
                facetDropdown.options.length = 0;
                let optFragment = new DocumentFragment();
                let placeholderOpt = document.createElement('option');
                    placeholderOpt.innerText = placeholder
                    placeholderOpt.value = "";
                if (_hpSearchLegacy) {
                    placeholderOpt.className = "disabled";
                    placeholderOpt.disabled = true;
                } else {
                    placeholderOpt.className = "";
                    placeholderOpt.disabled = false;
                }
                    placeholderOpt.selected = true;
                optFragment.appendChild(placeholderOpt);
                if(options.length > 0){
                    for (let index = 0; index < options.length; index++) {
                        let option = String(options[index]);
                        let opt = document.createElement('option');
                        opt.innerText = option;
                        opt.value = option;
                        optFragment.appendChild(opt);
                    }
                }
                facetDropdown.append(optFragment);

                const $facetDropdown = $(facetDropdown);
                if ($facetDropdown.data('select2')) {
                    $facetDropdown.select2('destroy');
                }
                if (__this._shouldUseSelect2ForHomeDropdown(isExternalRoot)) {
                    $facetDropdown.select2({
                        selectOnClose: true,
                        matcher: (params, data) => __this._matcher(params, data),
                        dropdownPosition: 'below',
                    });
                }

                if (!_hpSearchLegacy && !isExternalRoot && options.length > 0 && !suppressImprovedBlankReset) {
                    facetDropdown.value = "";
                    if ($facetDropdown.data('select2')) {
                        $facetDropdown.val("").trigger("change.select2");
                    }
                }
                if(dropdownId !== "searchYear" && options.length > 0 && isNextDropdownOpen == true){
                    const $openEl = $(facetDropdown);
                    const openHome = function () {
                        if ($openEl.attr("data-select2-id") && $openEl.data('select2')) {
                            $openEl.select2("open");
                        }
                    };
                    if (_hpSearchLegacy) {
                        openHome();
                    } else {
                        setTimeout(openHome, 300);
                    }
                }
            }
        }

    }

    var year, make, model, vinNumber;

    // Loader overlay uses .disabled-field (ajax-loader.gif). Leaving it on during
    // location redirects freezes the spinner in bfcache; browser Back restores it stuck.
    function clearFacetSearchLoaders() {
        $('.searchPadding_container .searchInnerCont, #fixed-filter-form, .fixed-filter-form')
            .removeClass('disabled-field');
    }

    window.addEventListener('pageshow', function () {
        clearFacetSearchLoaders();
    });

    $('body').on('click', '#mbk_vinSearchButton', function(event) {
        event.preventDefault();
        vinNumber = $('#mbk_vinSearchField').val().trim();
        
        if (!vinNumber) {
            $('#mbk_vinSearchField').css('border-color', '#ff0000');
                if (!$('.vinSearchField_inner .vinSearchField_error').length) {
                    $('.vinSearchField_inner').append(
                        '<div class="vinSearchField_error">Please enter a valid VIN number</div>'
                    );
                }
            $('#mbk_vinSearchField').focus();

        }else {

            $('#mbk_vinSearchField').css('border-color', '#d5d5d5');
            $('.vinSearchField_error').remove();
        
            $('.searchPadding_container .searchInnerCont').addClass('disabled-field');
            var vinAPI = `${API_BASE_URL}/vinCollectionMobikasa`;
            const vinURL = `${vinAPI}/${vinNumber}`;
            
            $.ajax({
                type: "GET",
                url: vinURL,
                crossOrigin: true,
                dataType: 'json',
                success: function (resData) {
                    if (resData.res === 'nodata') {
                        clearFacetSearchLoaders();
                        window.location.href = `/pages/not-available-in-pureflow`;
                        return;
                    }
            
                    let response = resData.res;
                    if (typeof response === "string") {
                        response = response.split(',').filter(Boolean).reverse();
                    }
                    year = response[0];
                    getMakeData([response[0], response[2], response[1]]);
                },
                error: function (err) {
                    clearFacetSearchLoaders();
                    console.error("AJAX Error:", err);
                    window.location.href = `/pages/not-available-in-pureflow`;
                }
            });
        }
    });

    function redirectVinSearchToNotAvailable() {
        clearFacetSearchLoaders();
        window.location.href = `/pages/not-available-in-pureflow`;
    }

    function getMakeData(data) {
    fetch(`${API_BASE_URL}/makeCollection/2/${data[0]}`, {
        method: "GET"

    }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
    }).then(api => {
        var optData = api;
        var matched = false;
        optData.forEach((item, index) => {
        if( item.make === data[1] ) {
            let optValue = `${item.MakeID}_${item.make}`;
            make = optValue;
            matched = true;
            fetchModelFunc(data);
        }
        });
        if (!matched) {
            redirectVinSearchToNotAvailable();
        }
    }).catch(error => {
        console.error('Error: ', error);
        redirectVinSearchToNotAvailable();
    });
    }

    function fetchModelFunc(data) {
    
    var spltMake = make.split('_');
    fetch(`${API_BASE_URL}/modelCollection/2/${year}/${spltMake[0]}`, {
        method: "GET",
    }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
    }).then(api => {
        var optData = api;
        var matched = false;
        optData.forEach((item, index) => {
            if( item.model === data[2] ) {
            let optValue = `${item.BaseVehicleID}_${item.model}`;
            model = optValue;
            matched = true;
            fetchEngineId();
            }
        });
        if (!matched) {
            redirectVinSearchToNotAvailable();
        }
    }).catch(error => {
        console.error('Error: ', error);
        redirectVinSearchToNotAvailable();
    });
    }

    function fetchEngineId() {
    var _baseVehicleId = model.split('_');
    fetch(`${API_BASE_URL}/engineCollection/${_baseVehicleId[0]}`, {
        method: "GET",
    }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
    }).then(api => {
        var optData = api;
        if (!optData || optData.length === 0) {
            redirectVinSearchToNotAvailable();
            return;
        }
        optData.forEach((item, index) => {
            let optValue = item.EngineConfigID;
            fetchPartNumbers(optValue);
        });
    }).catch(error => {
        console.error('Error: ', error);
        redirectVinSearchToNotAvailable();
    });
    }

    function fetchPartNumbers(engineID) {
    var _baseVehicleId = model.split('_');
    fetch(`${API_BASE_URL_NEW}/productList1/${_baseVehicleId[0]}/${engineID}/noqualifier/noqualifier`, {
        method: "GET",
    }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
    }).then(api => {
        const filteredPartTypeArray = (api.partTypeArray || []).filter(item => {
        const noteMatch = item?.note?.toLowerCase().includes("pureflow");
        const partNumberMatch = item?.partNumber?.toUpperCase().startsWith("RZ");
        return noteMatch || partNumberMatch;
    });

    const allPartTypeArray = [].concat(filteredPartTypeArray);

    if (allPartTypeArray.length === 0) {
        redirectVinSearchToNotAvailable();
        return;
    }

    let _products = allPartTypeArray.map((opt) => {
        return opt.partNumber;
    });

    fetchProducts(_products);
    }).catch(error => {
        console.error('Error: ', error);
        redirectVinSearchToNotAvailable();
    });
    }

    function fetchProducts(_products) {
    var _make = make.split('_');
    var _model = model.split('_');

    let formDataProduct = new FormData();
    formDataProduct.append("termYear", year);
    formDataProduct.append("termMake", _make[1]);
    formDataProduct.append("termModel", _model[1]);
    formDataProduct.append("partNumber", _products.join(","));
    fetch(API_PRODUCT_BASE_URL, {
        method: "POST",
        mode:"cors",
        body:formDataProduct
    }).then(response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
        
    }).then(api => {

        let _handles = api.response.map((product) => {
            return product.handle;
        });
        if(_handles?.length === 0){
            localStorage.setItem("selectedModel",model);
            localStorage.setItem("selectedMake",make);
            localStorage.setItem("selectedYear",year);
            clearFacetSearchLoaders();
            window.location.href = `/pages/not-available-in-pureflow`;
            return false;
        }
        // _handles.sort((a, b) => {
        //     const hasHepaA = a.includes("hepa");
        //     const hasHepaB = b.includes("hepa");
        
        //     if (hasHepaA && !hasHepaB) return 1;  
        //     if (!hasHepaA && hasHepaB) return -1; 
        //     return 0; 
        // });
        
        var urlModel = encodeURIComponent(model);
        var _subQuery = `termYear:${year}|termMake:${make}|termModel:${urlModel}`;
        Shopify?.analytics?.publish("on_vin_number_search", {
            number_search: vinNumber
        });
        clearFacetSearchLoaders();
        window.location.href = `/search?type=product&q=(handle:${_handles.join(" OR handle:")})&filter=carair@advance-filter=${_subQuery}&vin=${vinNumber}`;
    }).catch(error => {
        console.error('Error: ', error);
        redirectVinSearchToNotAvailable();
    });
    }



    // register custom element
    customElements.define("pur-facet-filter", PurFacetFilter);

    window.FACET_FILTER = window.FACET_FILTER || {};
    window.FACET_FILTER.getFacetFilterInstance = function getFacetFilterInstance() {
        let el = document.querySelector('pur-facet-filter');
        if (!el) {
            el = document.createElement('pur-facet-filter');
            el.hidden = true;
            el.setAttribute('aria-hidden', 'true');
            document.body.appendChild(el);
        }
        return el;
    };
    window.FACET_FILTER.initHeroHomeFilters = function initHeroHomeFilters(external = {}) {
        return window.FACET_FILTER.getFacetFilterInstance().initExternalHomeFilters(external);
    };
    window.FACET_FILTER.prepareIndexHomeFilters = function prepareIndexHomeFilters() {
        const el = document.querySelector('.template-index .advance-search-main pur-facet-filter')
            || document.querySelector('.template-index pur-facet-filter.homepage-filter-main');
        if (el && typeof el._prepareIndexHomeFilters === 'function') {
            return el._prepareIndexHomeFilters();
        }
        return Promise.resolve();
    };
}


function parseAndTriggerSelect2() {
    const params = new URLSearchParams(window.location.search);

    const hpSearch = params.get('hpSearch');
    if (!hpSearch) {
        return;
    }

    if(hpSearch){
        const entries = hpSearch.split(',');
        const data = {};
        entries.forEach(entry => {
            const [key, value] = entry.split(':');
            data[key.trim()] = value.trim();
        });
        const tabs = data.tab || null;

        if(tabs == "carFilter"){
            const year = data.teamYear || null;
            const make = data.termMake || null;
            const model = data.teamModel || null;
    
            function scrollAndSelect(selector, value, nextSelector) {
                const interval = setInterval(() => {
                    const $select = $(selector);
                    const hasData = $select.find('option').length > 1; 
                    const optionExists = $select.find(`option[value="${value}"]`).length > 0;
            
                    if (hasData && optionExists) {
                        const label = value.includes("_") ? value.split("_")[1] : value; 
                        $select.select2('open');
            
                        const $dropdown = $('.select2-results__options');
                        const $option = $dropdown.find(`li:contains("${label}")`);
            
                        if ($option.length) {
                            $option.trigger('mouseenter'); 
                            $option.trigger('click');
            
                            setTimeout(() => {
                                $select.select2('close');
                                if (nextSelector) {
                                    setTimeout(() => {
                                        $(nextSelector).select2('open');
                                    }, 100); 
                                }
                            }, 300);
            
                            clearInterval(interval); 
                        }
                    }
                }, 100);
            }
            
    
            if (year) {
                scrollAndSelect('#termYear', year, '#termMake');
            }
            if (make) {
                scrollAndSelect('#termMake', make, '#termModel');
            }
            if (model) {
                scrollAndSelect('#termModel', model, null);
            }
        }
    }
}

function parseAndTriggerHomeFilter() {
    const params = new URLSearchParams(window.location.search);
    const hpSearch = params.get('hpSearch');
    if (!hpSearch) {
        return;
    }

    if(hpSearch){
        const entries = hpSearch.split(',');
        const data = {};
        entries.forEach(entry => {
            const [key, value] = entry.split(':');
            data[key.trim()] = value.trim();
        });

        const tabs = data.tab || null;

        if(tabs == "homeFilter"){
            const homeTab = document.querySelector('.home-filter-tab .homeairtab');
            if(homeTab){
                homeTab.click();
            }
            
            const thickness = data.searchDepth || null;
            const width = data.searchWidth || null;
            const length = data.searchHeight || null;

            function scrollAndSelect(selector, value, nextSelector) {
                const interval = setInterval(() => {
                    const $select = $(selector);
                    const hasData = $select.find('option').length > 1; 
                    const optionExists = $select.find(`option[value="${value}"]`).length > 0;

                    if (hasData && optionExists) {
                        $select.select2('open');

                        const $dropdown = $('.select2-results__options'); 
                        const $option = $dropdown.find(`li:contains("${value}")`); 

                        if ($option.length) {
                            $option.trigger('mouseenter'); 
                            $option.trigger('click'); 

                            setTimeout(() => {
                                $select.select2('close');
                                if (nextSelector) {
                                    setTimeout(() => {
                                        $(nextSelector).select2('open');
                                    }, 100); 
                                }
                            }, 300);

                            clearInterval(interval);
                        }
                    }
                }, 100);
            }

            if (thickness) {
                scrollAndSelect('#searchDepth', thickness, '#searchWidth');
            }
            if (width) {
                scrollAndSelect('#searchWidth', width, '#searchHeight');
            }
            if (length) {
                scrollAndSelect('#searchHeight', length, null);
            }
        }
    }
}


$(document).ready(function () {
    parseAndTriggerSelect2();
    parseAndTriggerHomeFilter();
});
